import React, { useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./CreditsPurchaseOutcome.css";

const CreditsPurchaseOutcome = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const status = useMemo(() => (params.get("status") || "").toLowerCase(), [params]);
  const credits = useMemo(() => Number(params.get("credits") || 0), [params]);
  const ref = useMemo(() => params.get("ref") || "", [params]);

  const success = status === "success";

  return (
    <main className="home">
      <section className="checkout credits-outcome">
        <div className="checkout-header">
          <h2>
            Credits <span className="gradient-text">Purchase</span>
          </h2>
          <p className="checkout-subtitle">
            {success
              ? "Your credits purchase was verified successfully."
              : "We couldn’t confirm your credits purchase."}
          </p>
        </div>

        <div className="checkout-grid">
          <div className="checkout-card featured credits-outcome-card">
            <div className={`co-badge ${success ? "ok" : "bad"}`}>
              {success ? "Payment Successful" : "Payment Failed"}
            </div>

            {success ? (
              <p className="co-title">
                Added <b>{credits}</b> credits ✅
              </p>
            ) : (
              <p className="co-title">
                Please retry payment or check your card details.
              </p>
            )}

            <div className="co-actions">
              {success ? (
                <button className="primary-btn" onClick={() => navigate("/workspace", { replace: true })}>
                  Go to workspace
                </button>
              ) : (
                <>
                  <button className="primary-btn" onClick={() => navigate("/buy-credits", { replace: true })}>
                    Retry
                  </button>
                  <button className="secondary-btn" onClick={() => navigate("/workspace", { replace: true })}>
                    Back
                  </button>
                </>
              )}
            </div>

            <p className="tiny co-footnote">
              Reference: <span className="muted">{ref || "—"}</span>
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default CreditsPurchaseOutcome;
